import React, { useState, useEffect } from "react";
import { X } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Editor } from "@tinymce/tinymce-react";
import { useRef } from "react";
import Dropdown from "../../ui/Dropdown";
import { Dialog } from '@mui/material';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { getDefaultCountry } from '@/utils/helpers';
import UniversityRepeatableField from './UniversityRepeatableField';

export function FormPreviewModal({
  isOpen,
  onClose,
  formFields,
  onSave,
  form,
  tinymceConfig,
  setRadioConditionalValues = null,
  setCheckboxConditionalValues = null,
}) {
  const [isSaving, setIsSaving] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    // No need to set form name since we're removing the input field
  }, [form]);

  const [selectedOption, setSelectedOption] = useState(null);

  const [editorContent, setEditorContent] = useState("");


  const [localRadioConditionalValue, setLocalRadioConditionalValue] = useState([]);
  const [localCheckboxConditionalValue, setLocalCheckboxConditionalValue] = useState([]);
  const [phoneValues, setPhoneValues] = useState({});
  const [fieldErrors, setFieldErrors] = useState({});

  // Function to validate character limits
  const validateCharacterLimit = (value, field, index) => {
    if (!field.max_length) return true;
    
    const currentLength = value ? value.length : 0;
    const maxLength = parseInt(field.max_length);
    
    if (currentLength > maxLength) {
      setFieldErrors(prev => ({
        ...prev,
        [index]: `Maximum ${maxLength} characters allowed. You have entered ${currentLength} characters.`
      }));
      return false;
    } else {
      setFieldErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[index];
        return newErrors;
      });
      return true;
    }
  };

  // Function to handle input change with validation
  const handleInputChange = (e, field, index) => {
    const value = e.target.value;
    validateCharacterLimit(value, field, index);
  };
  
  useEffect(() => {
    if(setRadioConditionalValues){
      setRadioConditionalValues(localRadioConditionalValue);
    }
    if(setCheckboxConditionalValues){
      setCheckboxConditionalValues(localCheckboxConditionalValue);
    }
  }, [localRadioConditionalValue, localCheckboxConditionalValue]);



  //  fieldid .. triggervlue and conditional value
  const handleEditorChange = (content) => {
    const input = document.querySelector(
      `[name="fields[${index}][field_value]"]`
    );
    if (input) {
      input.value = content;
    }
  };

  if (!isOpen) return null;

  const [phoneDropdownStyle, setPhoneDropdownStyle] = useState({
    width: '600px',
  });
  const [phoneSearchStyle, setPhoneSearchStyle] = useState({
    width: '100%',
  });

  useEffect(() => {
    // on window resize, update the phone input dropdown width
    const handleResize = () => {
        // get with of .react-tel-input and set it to the dropdown width
        const container = document.querySelector('.react-tel-input');
        if (container) {
          setPhoneDropdownStyle({
            ...phoneDropdownStyle,
            width: `${container.offsetWidth}px`,
          });
          console.log("container", container, container.offsetWidth);
        }
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);


  const [conditionalVaues, setConditionalVaues] = useState({});

  const renderField = (field, index) => {
    const hiddenInputs = (
      <>
        <input
          type="hidden"
          name={`fields[${index}][field_name]`}
          value={field.label}
        />
        <input
          type="hidden"
          name={`fields[${index}][vacancy_custom_field_id]`}
          value={field.id || ""}
        />
        <input
          type="hidden"
          name={`fields[${index}][form_type]`}
          value={field.form_type || ""}
        />
        <input
          type="hidden"
          name={`fields[${index}][field_type]`}
          value={field.field_type || ""}
        />
      </>
    );

    switch (field.type) {
      case "text":
      case "url":
        return (
          <div className="mb-4">
            <label className="block text-foreground mb-1 font-semibold">
              {field.label}
              {field.is_required === "1" && (
                <span className="text-red-500 ml-1">*</span>
              )}
            </label>
              {field.sublabel && (
              <p className="block text-muted-foreground text-sm  ">
                {field.sublabel}
              </p>
            )}
          
            {hiddenInputs}
            <input
              name={`fields[${index}][field_value]`}
              type={field.type}
              placeholder={field.placeholder}
              maxLength={field.max_length ? parseInt(field.max_length) : undefined}
              className={`mt-1 block w-full px-3 py-[12px] border rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 min-h-10 ${
                fieldErrors[index] ? 'border-red-500' : 'border-input'
              }`}
              onChange={(e) => handleInputChange(e, field, index)}
              {...(field.is_required === "1" ? { required: true } : {})}
              {...(field.max_length ? { maxLength: field.max_length } : {})}
            />
            {fieldErrors[index] && (
              <p className="mt-1 text-sm text-red-600">
                {fieldErrors[index]}
              </p>
            )}
              {field.max_length && (
              <p className="block text-muted-foreground text-sm mt-1">
                Maximum {field.max_length} characters
              </p>
            )}
          
          </div>
        );

      case "number":
        return (
          <div className="mb-4">
            <label className="block text-foreground font-semibold mb-1">
              {field.label}
              {field.is_required === "1" && (
                <span className="text-red-500 ml-1">*</span>
              )}
            </label>
            {field.sublabel && (
              <p className="block text-muted-foreground text-sm -mt-0.5 mb-2">
                {field.sublabel}
              </p>
            )}
            {hiddenInputs}
            <input
              name={`fields[${index}][field_value]`}
              type="number"
              placeholder={field.placeholder}
              className="mt-1 block w-full px-3 py-[12px] border border-input rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 min-h-10"
              {...(field.is_required === "1" ? { required: true } : {})}
            />
          </div>
        );

      case "textarea":
      case "wysiwyg":
        return (
          <div className="mb-4">
            <label className="block text-foreground  mb-1 font-semibold">
              {field.label}
              {field.is_required === "1" && (
                <span className="text-red-500 ml-1">*</span>
              )}
            </label>
            {field.sublabel && (
              <p className="block text-muted-foreground text-sm -mt-0.5 mb-2">
                {field.sublabel}
              </p>
            )}
          
            {hiddenInputs}
            <textarea
              name={`fields[${index}][field_value]`}
              placeholder={field.placeholder}
              maxLength={field.max_length ? parseInt(field.max_length) : undefined}
              className={`mt-1 block w-full px-3 py-[12px] border rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 resize-none overflow-hidden ${
                fieldErrors[index] ? 'border-red-500' : 'border-input'
              }`}
              rows={10}
              onInput={(e) => {
                e.target.style.height = "auto";
                e.target.style.height = `${e.target.scrollHeight}px`;
                handleInputChange(e, field, index);
              }}
              {...(field.is_required === "1" ? { required: true } : {})}
              {...(field.max_length ? { maxLength: field.max_length } : {})}
            />
            {fieldErrors[index] && (
              <p className="mt-1 text-sm text-red-600">
                {fieldErrors[index]}
              </p>
            )}
              {field.max_length && (
              <p className="block text-muted-foreground text-sm mt-1">
                Maximum {field.max_length} characters
              </p>
            )}
          </div>
        );

      case "_wysiwyg":
        return (
          <div className="mb-4">
            <label className="block text-foreground font-semibold mb-1">
              {field.label}
              {field.is_required === "1" && (
                <span className="text-red-500 ml-1">*</span>
              )}
            </label>
            {field.sublabel && (
              <p className="block text-muted-foreground text-sm -mt-0.5 mb-2">
                {field.sublabel}
              </p>
            )}
            {hiddenInputs}
            <div className="mt-1">
              <Editor
                apiKey={import.meta.env.VITE_TINYMCE_API_KEY}
                init={{
                  ...tinymceConfig,
                  plugins: "autoresize",
                  min_height: 300,
                }}
                initialValue=""
                onEditorChange={(content) => {
                  setEditorContent(content);
                }}
              />

              <input
                type="hidden"
                name={`fields[${index}][field_value]`}
                value={editorContent}
                {...(field.is_required === "1" ? { required: true } : {})}
              />
            </div>
          </div>
        );

      case "heading":
        return (
          <div className="mb-4">
            {hiddenInputs}
            <h2
              className={`
              ${
                field.headingSize === "large"
                  ? "text-2xl"
                  : field.headingSize === "small"
                  ? "text-lg"
                  : "text-xl"
              }
              font-bold text-foreground
            `}
            >
              {field.label || "Heading"}
            </h2>
            {field.sublabel && (
              <p className="mt-1 text-muted-foreground">{field.sublabel}</p>
            )}
          </div>
        );

      case "select":
        return (
          <div className="mb-4">
            <label className="block text-foreground font-semibold mb-1">
              {field.label}
              {field.is_required === "1" && (
                <span className="text-red-500 ml-1">*</span>
              )}
            </label>
            {field.sublabel && (
              <p className="block text-muted-foreground text-sm -mt-0.5 mb-1">
                {field.sublabel}
              </p>
            )}
            {hiddenInputs}
            <Dropdown
              options={
                field.options?.map((option) => ({
                  label: option,
                  value: option,
                })) || []
              }
              value={selectedOption?.[`select_${+index}`] || ""}
              onChange={(selected) => {
                const input = document.querySelector(
                  `[name="fields[${index}][field_value]"]`
                );
                if (input) {
                  input.value = selected?.value || "";
                  setSelectedOption((prev) => ({
                    ...prev,
                    [`select_${+index}`]: selected?.value || "",
                  }));
                }
              }}
              placeholder="Select an option"
              className="mt-1 border border-input text-muted-foreground rounded-md "
              triggerClassName="!bg-transparent"
              searchable={true}
            />
            <input
              type="hidden"
              name={`fields[${index}][field_value]`}
              value={selectedOption?.[`select_${+index}`] || ""}
              {...(field.is_required === "1" ? { required: true } : {})}
            />
          
          </div>
        );

      case "file":
        return (
          <div className="mb-4">
            <label className="block text-foreground font-semibold mb-1">
              {field.label}
              {field.is_required === "1" && (
                <span className="text-red-500 ml-1">*</span>
              )}
            </label>
            {field.sublabel && (
              <p className="block text-muted-foreground text-sm -mt-0.5 mb-2">
                {field.sublabel}
              </p>
            )}
            {hiddenInputs}
            <input
              name={`fields[${index}][field_value]`}
              type="file"
              accept=".pdf"
              className="mt-1 block w-full px-3 py-[5px] border border-input rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 min-h-10"
              {...(field.is_required === "1" ? { required: true } : {})}
            />
          </div>
        );

      case "image":
        return (
          <div className="">
            <label className="block text-foreground font-semibold mb-1">
              {field.label}
              {field.is_required === "1" && (
                <span className="text-red-500 ml-1">*</span>
              )}
            </label>
            {field.sublabel && (
              <p className="block text-muted-foreground text-sm -mt-0.5 mb-2">
                {field.sublabel}
              </p>
            )}
            {hiddenInputs}
            <div className={`text-${field.alignment || "left"}`}>
              {/* <div className="inline-block border-2 border-dashed border-input rounded-lg p-4">
                <div className="text-center">
                  <p className="text-sm text-muted-foreground">Image preview</p>
                </div>
              </div> */}
            </div>
            <input
              name={`fields[${index}][field_value]`}
              type="file"
              accept="image/*"
              className=" block w-full px-3 py-[12px] border border-input rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 min-h-10"
              {...(field.is_required === "1" ? { required: true } : {})}
            />
          </div>
        );

      case "spacer":
        return (
          <div className="mb-4">
            {hiddenInputs}
            <hr className="border-t border-border" />
          </div>
        );

      case "phone":
      case "tel":
        return (
          <div className="mb-4">
            <label className="block text-foreground font-semibold mb-1">
              {field.label}
              {field.is_required === "1" && (
                <span className="text-red-500 ml-1">*</span>
              )}
            </label>
            {field.sublabel && (
              <p className="block text-muted-foreground text-sm -mt-0.5 mb-[5px]">
                {field.sublabel}
              </p>
            )}
            {hiddenInputs}
            <div className="relative">
              <PhoneInput
                country={getDefaultCountry()?.toLowerCase() || 'gb'}
                value={phoneValues[field.id] || ''}
                onChange={(value, country) => {
                  // Update the phone values state
                  setPhoneValues(prev => ({
                    ...prev,
                    [field.id]: value || ''
                  }));
                  
                  // Update the hidden input for form submission
                  const input = document.querySelector(
                    `[name="fields[${index}][field_value]"]`
                  );
                  if (input) {
                    input.value = value || '';
                  }
                }}
                placeholder={field.placeholder || "Enter phone number"}
                enableSearch={true}
                searchPlaceholder="Search country..."
                inputClass="mt-1 block  px-3 py-[12px] border border-input rounded-md shadow-sm focus:outline-none min-w-[100%] min-h-[50px]"
                // containerClass="phone-input-container"
                buttonClass="phone-input-button"
                // dropdownClass="phone-input-dropdown"
                dropdownStyle={phoneDropdownStyle}
                searchStyle={phoneSearchStyle}
                {...(field.is_required === "1" ? { required: true } : {})}
              />
              {/* Hidden input for form submission */}
              <input
                type="hidden"
                name={`fields[${index}][field_value]`}
                value={phoneValues[field.id] || ''}
                {...(field.is_required === "1" ? { required: true } : {})}
              />
              {/* Validation message */}
              {phoneValues[field.id] && phoneValues[field.id].length < 10 && (
                <p className="mt-1 text-sm text-red-600">
                  Please enter a valid phone number
                </p>
              )}
            </div>
          </div>
        );

      
      case "email":
        return (
          <div className="mb-4">
            <label className="block text-foreground font-bold mb-1">
              {field.label}
              {field.is_required === "1" && (
                <span className="text-red-500 ml-1">*</span>
              )}
            </label>
            {field.sublabel && (
              <p className="block text-muted-foreground text-sm -mt-0.5 mb-2">
                {field.sublabel}
              </p>
            )}
           
            {hiddenInputs}
            <input
              name={`fields[${index}][field_value]`}
              type="email"
              placeholder={field.placeholder}
              maxLength={field.max_length ? parseInt(field.max_length) : undefined}
              className={`mt-1 block w-full px-3 py-[12px] border rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 min-h-10 ${
                fieldErrors[index] ? 'border-red-500' : 'border-input'
              }`}
              onChange={(e) => handleInputChange(e, field, index)}
              {...(field.is_required === "1" ? { required: true } : {})}
            />
            {fieldErrors[index] && (
              <p className="mt-1 text-sm text-red-600">
                {fieldErrors[index]}
              </p>
            )}
             {field.max_length && (
              <p className="block text-muted-foreground text-sm mt-1">
                Maximum {field.max_length} characters
              </p>
            )}
          </div>
        );

      case "university_repeatable":
        return (
          <div className="mb-4">
            <label className="block  text-xl font-semibold mb-1">
              {field.label}
              {field.is_required === "1" && (
                <span className="text-red-500 ml-1">*</span>
              )}
            </label>
            {field.sublabel && (
              <p className="block text-muted-foreground text-sm -mt-0.5 mb-2">
                {field.sublabel}
              </p>
            )}
            {hiddenInputs}
            <UniversityRepeatableField 
              fieldIndex={index}
              field={field}
              isRequired={field.is_required === "1"}
            />
          </div>
        );

      case "radio":
        return (
          <div className="mb-4">
            <label className="block text-foreground font-semibold mb-1">
              {field.label}
              {field.is_required === "1" && (
                <span className="text-red-500 ml-1">*</span>
              )}
            </label>
            
              {field.sublabel && (
              <p className="block text-muted-foreground text-sm mb-2  ">
                {field.sublabel}
              </p>
            )}
            {hiddenInputs}
            <div className="grid grid-cols-2 gap-4">
              {Array.isArray(field.options) &&
                field.options.map((option, sub_index) => {
                  const isConditional =
                    field.conditions &&
                    field.conditions.some(
                      (cond) => cond.trigger_value === option
                    );

                  return (
                    <div
                      key={`${index}-${sub_index}`}
                      className={isConditional ? "conditional-field" : ""}
                    >
                      <label className="flex items-center gap-2 p-3 border border-input rounded-md hover:border-muted-foreground cursor-pointer w-full">
                        <input
                          name={`fields[${index}][field_value]`}
                          type="radio"
                          value={option}
                          className="text-foreground"
                          {...(field.is_required === "1"
                            ? { required: true }
                            : {})}
                          onChange={(e) => {
                            // Log the selected radio value
                            console.log("Radio Value:", e.target.value);

                            // Hide all conditional inputs for this radio group first
                            field.options.forEach((_, i) => {
                              const conditionalInput = document.getElementById(
                                `conditional-input-${index}-${i}`
                              );
                              if (conditionalInput) {
                                conditionalInput.style.display = "none";
                              }
                            });
                            if(field.has_condition
                              && option == field?.conditions[0]?.trigger_value
                              && e.target.checked
                            ){
                              setConditionalVaues({...conditionalVaues, [field.id]: true});
                            }
                            else{
                              setConditionalVaues({...conditionalVaues, [field.id]: false});
                            }

                            // Then show the selected one if it's conditional
                            // if (isConditional) {
                            //   const conditionalInput = document.getElementById(
                            //     `conditional-input-${index}-${sub_index}`
                            //   );
                            //   if (conditionalInput) {
                            //     conditionalInput.style.display = e.target
                            //       .checked
                            //       ? "block"
                            //       : "none";
                            //     if (e.target.checked) {
                            //       const conditionalValue =
                            //         conditionalInput.querySelector(
                            //           "input"
                            //         ).value;
                            //       e.target.value = `${option}${
                            //         conditionalValue
                            //           ? `: ${conditionalValue}`
                            //           : ""
                            //       }`;
                            //     }
                            //   }
                            // }
                          }}
                        />
                        <span className="text-foreground flex-1">{option}</span>
                      </label>
                      {(isConditional && false) &&
                        field.conditions.map(
                          (condition, condIndex) =>
                            condition.trigger_value === option && (
                              <div
                                key={condIndex}
                                id={`conditional-input-${index}-${sub_index}`}
                                className="mt-2 ml-6"
                                style={{ display: "none" }}
                              >
                                <label className="block text-foreground text-sm mb-1">
                                  {condition.label || "Please specify"}
                                </label>
                                <input
                                  type="text"
                                  name={`fields[${index}][conditional_value]`}
                                  placeholder={condition.placeholder}
                                  className="w-full px-3 py-2 border border-input rounded-md"
                                  required={!!condition.placeholder}
                                  onChange={(e) => {

                                    const radio = document.querySelector(
                                      `input[name="fields[${index}][field_value]"][value^="${option}"]`
                                    );
                                    if (radio) {
                                      radio.value = `${option}${
                                        e.target.value
                                          ? `: ${e.target.value}`
                                          : ""
                                      }`;
                                    }
                                  }}
                                />
                              </div>
                            )
                        )}
                    </div>
                  );
                })}
            </div>
          </div>
        );


      case "checkbox":
        const [selectedValues, setSelectedValues] = useState([]);
        const [conditionalValues, setConditionalValues] = useState({});

        const handleCheckboxChange = (option, isChecked) => {
          if (isChecked) {
            setSelectedValues([...selectedValues, option]);
          } else {
            setSelectedValues(
              selectedValues.filter((value) => value !== option)
            );
            // Remove conditional value when checkbox is unchecked
            setConditionalValues((prev) => {
              const newValues = { ...prev };
              delete newValues[option];
              return newValues;
            });
          };
        };

        const handleConditionalChange = (option, value) => {
          setConditionalValues((prev) => ({
            ...prev,
            [option]: value,
          }));
        };

        // Combine selected values with their conditional values
        const combinedValues = selectedValues
          .map((option) => {
            const conditionalValue = conditionalValues[option];
            return conditionalValue ? `${option}: ${conditionalValue}` : option;
          })
          .join(",");

        return (
          <div className="mb-4">
            <label className="block text-foreground font-semibold mb-1">
              {field.label}
              {field.is_required === "1" && (
                <span className="text-red-500 ml-1">*</span>
              )}
            </label>
            {field.sublabel && (
              <p className="block text-muted-foreground text-sm -mt-0.5 mb-2">
                {field.sublabel}
              </p>
            )}
            {hiddenInputs}
            <div className="grid grid-cols-2 gap-4">
              {Array.isArray(field.options) &&
                field.options.map((option, sub_index) => {
                  const isConditional = field.conditions?.some(
                    (condition) => condition.trigger_value === option
                  );

                  return (
                    <div
                      key={`${index}-${sub_index}`}
                      className={isConditional ? "conditional-field" : ""}
                    >
                      <label className="flex items-center gap-2 p-3 border border-input rounded-md hover:border-muted-foreground cursor-pointer w-full">
                        <input
                          name={`fields[${index}][field_value][]`}
                          type="checkbox"
                          id={`${field.id}-${index}-${sub_index}`}
                          value={option}
                          checked={selectedValues.includes(option)}
                          onChange={(e) => {

                            handleCheckboxChange(option, e.target.checked);
                            if(field.has_condition
                              && option == field?.conditions[0]?.trigger_value
                              && e.target.checked
                            ){         
                                                   
                              setConditionalVaues({...conditionalVaues, [field.id]: true});
                            }
                            else{
                              setConditionalVaues({...conditionalVaues, [field.id]: false});
                            }
                            // console.log("conditionalVaues", conditionalVaues, option, field?.conditions[0]?.trigger_value);
                            // const conditionalInput = document.getElementById(
                            //   `conditional-input-${index}-${sub_index}`
                            // );
                            // if (isConditional && conditionalInput) {
                            //   conditionalInput.style.display = e.target.checked
                            //     ? "block"
                            //     : "none";
                            // }
                          }}
                          className="h-4 w-4 text-blue-600 border-input rounded focus:ring-blue-500"
                        />
                        <span className="text-foreground flex-1">{option}</span>
                      </label>
                      {(isConditional && false) &&
                        field.conditions
                          .filter(
                            (condition) => condition.trigger_value === option
                          )
                          .map((condition, condIndex) => (
                            <div
                              key={condIndex}
                              id={`conditional-input-${index}-${sub_index}`}
                              className="mt-2 ml-6"
                              style={{ display: "none" }}
                            >
                              <label className="block text-foreground text-sm mb-1">
                                {condition.label || "Please specify"}
                              </label>
                              <input
                                type="text"
                                name={`fields[${index}][conditional_values][${option}]`}
                                placeholder={condition.placeholder}
                                className="w-full px-3 py-2 border border-input rounded-md"
                                required={!!condition.placeholder}
                                onChange={(e) =>
                                  handleConditionalChange(
                                    option,
                                    e.target.value
                                  )
                                }
                              />
                            </div>
                          ))}
                    </div>
                  );
                })}
            </div>
            {/* Hidden input to ensure the field is submitted with both values and conditions */}
            <input
              type="hidden"
              name={`fields[${index}][field_value]`}
              value={combinedValues}
            />
          </div>
        );
  

      case "date":
        return (
          <div className="mb-4">
            <label className="block text-foreground font-semibold mb-1">
              {field.label}
              {field.is_required === "1" && (
                <span className="text-red-500 ml-1">*</span>
              )}
            </label>
            {field.sublabel && (
              <p className="block text-muted-foreground text-sm -mt-0.5 mb-2">
                {field.sublabel}
              </p>
            )}
            {hiddenInputs}
            <input
              name={`fields[${index}][field_value]`}
              type="date"
              placeholder={field.placeholder}
              className="mt-1 block w-full px-3 py-[12px] border border-input rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 min-h-10"
              {...(field.is_required === "1" ? { required: true } : {})}
            />
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className="flex-1 px-6 pt-6">
      <div className=" mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {formFields.map((field, index) => (
            <div
              key={field.id || index}
              className={
                [
                  "heading",
                  "textarea",
                  "spacer",
                  "wysiwyg",
                  "radio",
                  "checkbox",
                  "university_repeatable",
                ].includes(field.type)
                  ? "col-span-1 md:col-span-2"
                  : "col-span-1"
              }
            >
              {renderField(
                {
                  ...field,
                },
                index
              )}
              {(field.has_condition && conditionalVaues[field.id] == true) && (
              <div
                key={`conditional-input-${index}`}
                id={`conditional-input-${index}`}
                className="mt-2 ml-6"
              >
                <label className="block text-foreground text-sm mb-1">
                  {field.conditions[0].label || "Please specify"}
                </label>
                <input
                  type="text"
                  name={field.type == "radio" ? `fields[${index}][conditional_value]` : `fields[${index}][conditional_values][${field.conditions[0].trigger_value}]`}
                  placeholder={field.conditions[0].placeholder}
                  className="w-full px-3 py-2 border border-input rounded-md"
                  required={!!field.conditions[0].placeholder}
                  {...(field.max_length ? { maxLength: field.max_length } : {})}
                  onChange={(e) => {
                    const sanitizedValue = e.target.value.replace(/,/g, '|');
                    if(field.type == "radio"){
                      const existingIndex = localRadioConditionalValue.findIndex(item => 
                        item.fieldid === field.id && 
                        item.triggervlue === field.conditions[0].trigger_value
                      );
                      
                      if (existingIndex === -1) {
                        setLocalRadioConditionalValue([...localRadioConditionalValue, 
                          {
                            fieldid: field.id, 
                            triggervlue: field.conditions[0].trigger_value, 
                            conditionalvalue: sanitizedValue
                          }
                        ]);
                      } else {
                        const updatedValues = [...localRadioConditionalValue];
                        updatedValues[existingIndex].conditionalvalue = sanitizedValue;
                        setLocalRadioConditionalValue(updatedValues);
                      }

                    }
                    else if(field.type == "checkbox"){
                      const existingIndex = localCheckboxConditionalValue.findIndex(item => 
                        item.fieldid === field.id && 
                        item.triggervlue === field.conditions[0].trigger_value
                      );
                      
                      if (existingIndex === -1) {
                        setLocalCheckboxConditionalValue([...localCheckboxConditionalValue, 
                            {
                              fieldid: field.id, 
                              triggervlue: field.conditions[0].trigger_value, 
                              conditionalvalue: sanitizedValue
                            }
                        ]);
                      } else {
                        const updatedValues = [...localCheckboxConditionalValue];
                        updatedValues[existingIndex].conditionalvalue = sanitizedValue;
                        setLocalCheckboxConditionalValue(updatedValues);
                      }
                    }
                  }}
                />
              </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
